<template>
  <v-container class="content unsupported-browser-page">
    <LoginLogo />

    <v-row no-gutters justify="center" align="center" class="text-center mb-4">
      <h1>Unsupported browser</h1>
    </v-row>

    <v-row no-gutters justify="center" align="center" class="text-center mb-6">
      <div>
        TubeWay does not support your current browser.
        <div class="mt-2">
          Detected browser: <strong>{{ detectedBrowserLabel }}</strong>
        </div>
      </div>
    </v-row>

    <v-row no-gutters justify="center" align="center" class="text-center mb-3">
      <h2 class="supported-browsers-title">Supported browsers</h2>
    </v-row>

    <div class="supported-browsers-list">
      <div
        v-for="browser in supportedBrowsers"
        :key="browser.name"
        class="supported-browser-item"
      >
        <v-icon :icon="browser.icon" size="28" class="supported-browser-icon" />
        <div class="supported-browser-name">{{ browser.name }} {{ browser.minimumVersion }}+</div>
      </div>
    </div>
  </v-container>
</template>

<script>
import Helper from '@/components/helper.js';
import LoginLogo from '@/routes/account/components/LoginLogo.vue';

export default {
  name: 'UnsupportedBrowserPage',
  components: {
    LoginLogo,
  },
  computed: {
    detectedBrowserLabel: function() {
      return Helper.getBrowserName();
    },
    supportedBrowsers: function() {
      return Helper.getSupportedBrowsers();
    },
  },
}
</script>

<style scoped lang="scss">
.unsupported-browser-page {
  .supported-browsers-title {
    font-size: 1.125rem;
    font-weight: 600;
  }

  .supported-browsers-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .supported-browser-item {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px;
    border-radius: 12px;
    background-color: rgba(255, 255, 255, 0.04);
  }

  .supported-browser-icon {
    flex-shrink: 0;
  }

  .supported-browser-name {
    font-weight: 600;
  }
}
</style>
